import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { take } from 'rxjs';
import { CurrentFacilityService } from '../../services';

@Component({
    standalone: true,
    selector: 'app-svg-icon',
    templateUrl: './svg-icon.component.html',
    styleUrls: ['./svg-icon.component.scss'],
})
export class SVGIconComponent implements OnInit {
    public facilityName: string;
    public svgIcon: SafeHtml;

    @Input() name: string;

    constructor(
        private httpClient: HttpClient,
        private sanitizer: DomSanitizer,
        private currentFacilityService: CurrentFacilityService
    ) {}

    ngOnInit(): void {
        this.facilityName = this.currentFacilityService.getFacilitySource();

        this.getSVGIcon();
    }

    getSVGIcon(): void {
        this.httpClient
            .get(`assets/${this.facilityName}/img/${this.name}.svg`, {
                responseType: 'text',
            })
            .pipe(take(1))
            .subscribe((value) => {
                this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
            });
    }
}
